const WAY_LPR_SOURCE_EVENTS = new Set([
  'way-single-wash',
  'way-active-subscription',
  'way-purchase-selection',
]);

/** True when a completed notification row represents a Way purchase redemption. */
export function isWayRedeemedNotificationRow(
  row: Record<string, any> | null | undefined
): boolean {
  if (!row) {
    return false;
  }
  if (String(row['way_pass_id'] ?? row['wayPassId'] ?? '').trim()) {
    return true;
  }
  const purchase = row['purchase'];
  if (purchase && typeof purchase === 'object' && !Array.isArray(purchase)) {
    const purchaseRow = purchase as Record<string, any>;
    if (String(purchaseRow['way_pass_id'] ?? purchaseRow['wayPassId'] ?? '').trim()) {
      return true;
    }
  }
  const sourceEvents = row['source_events'];
  if (Array.isArray(sourceEvents)) {
    return sourceEvents.some(event => WAY_LPR_SOURCE_EVENTS.has(String(event ?? '').trim()));
  }
  return false;
}
